import { renderLucideIcon } from '../utils/lucide-icons.js'
import { renderPopin } from './popin-renderer.js'

function renderAttentionPointsPopin(state) {
  state = state || {}
  var alertCount = Array.isArray(state.items) ? state.items.length : 0
  var body = state.loading
    ? '<div class="wc-attention-empty">Chargement des points d’attention…</div>'
    : state.error
      ? '<div class="wc-attention-empty">Impossible de charger les points d’attention.</div>'
      : renderAttentionPointsBody(state.items)

  return renderPopin({
    title: 'Points d’attention',
    ariaLabel: 'Points d’attention',
    className: 'wc-attention-points-popin',
    header: '<div class="wc-popin-title">' + renderLucideIcon('bell') + '<span>Points d’attention</span></div>',
    body: '<div class="wc-attention-tabs" role="tablist" aria-label="Catégories de points d’attention">' +
      '<button type="button" class="wc-attention-tab is-active" role="tab" aria-selected="true">Alertes <span class="wc-attention-tab-count">' + alertCount + '</span></button>' +
      '<button type="button" class="wc-attention-tab" role="tab" aria-selected="false" aria-disabled="true" disabled>Notifications</button>' +
    '</div>' +
    '<div class="wc-attention-points-body" role="tabpanel">' + body + '</div>'
  })
}

function renderAttentionPointsBody(items) {
  if (!Array.isArray(items) || !items.length) {
    return '<div class="wc-attention-empty"><strong>Aucun point d’attention</strong><span>Aucune alerte active ne vous concerne actuellement.</span></div>'
  }

  return '<div class="wc-attention-list">' + items.map(renderAttentionPoint).join('') + '</div>'
}

function renderOperationalAgenda(response) {
  var activities = response && response.activities ? response.activities : {}
  var groups = [
    { key: 'overdue', title: 'Activités en retard' },
    { key: 'today', title: "Activités d'aujourd'hui" },
    { key: 'upcoming', title: 'Activités à venir' }
  ]
  return groups.map(function (group) {
    var rows = Array.isArray(activities[group.key]) ? activities[group.key] : []
    if (!rows.length) return ''
    return '<section class="wc-agenda-group wc-agenda-group--' + group.key + '">' +
      '<h3>' + escapeHtml(group.title) + '</h3>' +
      '<div class="wc-agenda-list">' + rows.map(renderActivity).join('') + '</div>' +
    '</section>'
  }).join('')
}

function renderActivity(activity) {
  var title = activity && activity.title || activity && activity.type || 'Activité'
  var date = formatActivityDate(activity && activity.startAt)
  var status = activity && activity.status ? String(activity.status) : ''
  var action = activity && activity.category === 'upcoming' && isBriefingActivity(activity)
    ? '<button type="button" class="wc-attention-action wc-agenda-briefing" data-activity-briefing="' + escapeAttribute(activity.id) + '">Préparer avec @Briefing</button>'
    : ''
  return '<article class="wc-agenda-card">' +
    '<div class="wc-agenda-card-main"><strong>' + escapeHtml(title) + '</strong>' +
      (date ? '<span>' + escapeHtml(date) + '</span>' : '') +
      (status ? '<span>' + escapeHtml(status) + '</span>' : '') +
    '</div>' + action +
  '</article>'
}

function formatActivityDate(value) {
  if (!value) return ''
  var formatted = formatFrenchDate(value)
  if (!formatted) return ''
  var date = new Date(value)
  if (Number.isNaN(date.getTime())) return formatted
  return formatted + ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes())
}

function isBriefingActivity(activity) {
  var type = String(activity && activity.type || '').toLowerCase()
  return type === 'meeting' || type === 'rendez-vous' || type === 'appointment' || type === 'call'
}

function renderAttentionPoint(item) {
  var importance = item && item.importance ? String(item.importance) : ''
  var object = item && item.object ? item.object : {}
  var label = object.label || object.type || 'Objet métier'
  var entityLabel = object.type === 'deal' && object.entityLabel ? String(object.entityLabel) : ''
  var actions = Array.isArray(item && item.suggestedActions) ? item.suggestedActions : []
  return '<article class="wc-attention-card">' +
    '<div class="wc-attention-card-head">' +
      '<div class="wc-attention-object"><strong>' + escapeHtml(label) + '</strong>' +
        (entityLabel ? '<span class="wc-attention-object-entity">' + escapeHtml(entityLabel) + '</span>' : '') +
      '</div>' +
      (importance ? '<span class="wc-attention-importance wc-attention-importance--' + escapeAttribute(importance) + '">' + escapeHtml(formatImportance(importance)) + '</span>' : '') +
    '</div>' +
    '<p class="wc-attention-justification">' + escapeHtml(formatAlertText(item.justification || '')) + '</p>' +
    renderExplanation(item.explanation, item) +
    '<div class="wc-attention-actions">' +
      (actions.length ? actions.map(function (action, index) { return renderAction(action, item, index) }).join('') : '') +
      renderDecisions(item) +
    '</div>' +
  '</article>'
}

function formatAlertText(value) {
  return String(value || '').replace(/\b(\d{4})-(\d{2})-(\d{2})\b/g, '$3/$2/$1')
}

function renderDecisions(item) {
  if (!item || !item.id) return ''
  return '<div class="wc-attention-decisions">' +
    '<div class="wc-attention-dropdown">' +
      '<button type="button" class="wc-attention-decision-button" data-alert-snooze-toggle aria-expanded="false">Reporter ' + renderLucideIcon('chevronDown', { size: 16 }) + '</button>' +
      '<div class="wc-attention-menu" data-alert-snooze-menu hidden>' +
        '<button type="button" data-alert-decision="snoozed" data-alert-id="' + escapeAttribute(item.id) + '" data-snooze-days="1">Reporter de 24 h</button>' +
        '<button type="button" data-alert-decision="snoozed" data-alert-id="' + escapeAttribute(item.id) + '" data-snooze-days="7">Reporter de 7 jours</button>' +
      '</div>' +
    '</div>' +
    '<button type="button" class="wc-attention-ignore" data-alert-decision="ignored" data-alert-id="' + escapeAttribute(item.id) + '">Ignorer</button>' +
  '</div>'
}

function renderExplanation(explanation, item) {
  if (!explanation) return ''
  var facts = Array.isArray(explanation.facts) ? explanation.facts : []
  var factsHtml = facts.length
    ? '<ul class="wc-attention-facts">' + facts.map(function (fact) {
      var value = fact.available ? formatFactValue(fact.value) : 'Donnée indisponible'
      return '<li><span>' + escapeHtml(fact.label || fact.field || 'Donnée') + '</span><strong>' + escapeHtml(value) + '</strong></li>'
    }).join('') + '</ul>'
    : '<p class="wc-attention-explanation-muted">Aucune donnée de preuve détaillée n’est disponible.</p>'
  var incompleteMessage = explanation.complete === false
    ? '<p class="wc-attention-explanation-warning">' + escapeHtml(explanation.message || 'La justification ne peut pas être complète avec les données disponibles.') + '</p>'
    : ''
  var ruleLabel = formatRuleLabel(explanation.ruleKey || item && item.ruleKey || explanation.ruleType || item && item.ruleType)
  return '<button type="button" class="wc-attention-explanation-toggle" data-attention-explanation aria-expanded="false">Voir pourquoi</button>' +
    '<div class="wc-attention-explanation" hidden>' +
      '<div class="wc-attention-explanation-rule"><span>Règle déclenchée</span><strong>' + escapeHtml(ruleLabel) + '</strong></div>' +
      '<div class="wc-attention-explanation-facts"><span>Faits connus</span>' + factsHtml + '</div>' +
      incompleteMessage +
    '</div>'
}

function formatRuleLabel(value) {
  var labels = {
    'deal.expected-close-date-approaching': 'Date de clôture prévue proche',
    'deal.expected-close-date-overdue': 'Date de clôture prévue dépassée',
    'deal.missing-next-action': 'Prochaine action manquante',
    'deal.stale': 'Opportunité sans activité récente',
    'entity.stale-commercial-interaction': 'Client sans interaction commerciale récente',
    'project.deadline-overdue': 'Échéance du projet dépassée'
  }
  var key = String(value || '').trim()
  return labels[key] || 'Condition métier'
}

function formatFactValue(value) {
  var date = formatFrenchDate(value)
  if (date) return date
  if (value && typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

function formatFrenchDate(value) {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return ''
    return formatDateParts(value.getDate(), value.getMonth() + 1, value.getFullYear())
  }
  var text = String(value || '').trim()
  var dateOnlyMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (dateOnlyMatch) return formatDateParts(Number(dateOnlyMatch[3]), Number(dateOnlyMatch[2]), Number(dateOnlyMatch[1]))
  if (!/^\d{4}-\d{2}-\d{2}T/.test(text)) return ''
  var date = new Date(text)
  if (Number.isNaN(date.getTime())) return ''
  return formatDateParts(date.getDate(), date.getMonth() + 1, date.getFullYear())
}

function formatDateParts(day, month, year) {
  return pad(day) + '/' + pad(month) + '/' + year
}

function pad(value) {
  return String(value).padStart(2, '0')
}

function formatImportance(value) {
  return String(value).toLowerCase() === 'critical' ? 'critique' : value
}

function renderAction(action, item, index) {
  var icon = action.icon || 'bot'
  var iconMarkup = renderLucideIcon(icon) || renderLucideIcon('bot')
  var capabilityLabel = resolveCapabilityLabel(action.capabilityKey)
  return '<button type="button" class="wc-attention-action" data-alert-action-index="' + escapeAttribute(String(index)) + '" data-alert-id="' + escapeAttribute(item && item.id) + '" aria-label="' + escapeAttribute(action.label || 'Action') + '">' +
    '<span class="wc-attention-action-label">' + escapeHtml(action.label || action.capabilityKey || 'Action') + '</span>' +
    '<span class="wc-attention-action-chip">' + iconMarkup + '<span>' + escapeHtml(capabilityLabel) + '</span></span>' +
  '</button>'
}

function resolveCapabilityLabel(capabilityKey) {
  var labels = {
    WRITE_EMAIL: '@Plume',
    BRIEFING: '@Briefing',
    DEBRIEF: '@Debrief',
    DICTATION: '@Dictée',
    SUMMARIZE: '@Synthèse',
    RADAR: '@Radar'
  }
  var key = String(capabilityKey || '').toUpperCase()
  return labels[key] || (key ? '@' + key : '@Cap')
}

function escapeHtml(value) {
  return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
}

function escapeAttribute(value) {
  return escapeHtml(value).replace(/`/g, '&#96;')
}

export { renderAttentionPointsBody, renderAttentionPointsPopin, renderOperationalAgenda }
